import React, { useState } from 'react';
import { Heart, MessageCircle, ExternalLink, Instagram } from 'lucide-react';

const InstagramPost = ({ post }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Use media_url for the image/video
    const mediaUrl = post.media_url || `/api/placeholder/600/600`;

    // Parse timestamp
    const postDate = new Date(post.timestamp);

    // Truncate caption
    const truncateCaption = (caption, maxLength = 100) => {
        return caption.length > maxLength
            ? caption.substring(0, maxLength) + '...'
            : caption;
    };

    console.log('Rendering InstagramPost for:', post.username, 'Media URL:', mediaUrl);
    console.log(post);

    return (
        <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 h-full">
            <div className="relative">
                {/* Post Media */}
                <div className="aspect-square bg-gray-100 overflow-hidden">
                    {post.media_product_type === 'REELS' ? (
                        <video
                            src={mediaUrl}
                            poster={post.thumbnail_url || `/api/placeholder/600/600`}
                            playsInline
                            preload="metadata"
                            muted
                            className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            onLoadedMetadata={() => setLoading(false)}
                            onError={() => {
                                setLoading(false);
                                setError(true);
                            }}
                            controls
                        />
                    ) : (
                        <img
                            src={mediaUrl}
                            alt="Instagram post"
                            className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            onLoad={() => setLoading(false)}
                            onError={() => {
                                setLoading(false);
                                setError(true);
                            }}
                        />
                    )}

                    {loading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                            <div className="w-10 h-10 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    )}
                </div>

                {/* Instagram Logo Overlay */}
                <div className="absolute top-4 right-4 bg-white bg-opacity-90 p-1.5 rounded-full shadow-sm">
                    <Instagram size={18} className="text-teal-500" />
                </div>
            </div>

            {/* Post Content */}
            <div className="p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center">
                            <span className="text-teal-500 text-xs font-bold">
                                {post.username.substring(0, 2).toUpperCase()}
                            </span>
                        </div>
                        <span className="text-sm font-medium text-gray-800">
                            @{post.username}
                        </span>
                    </div>
                    <span className="text-xs text-gray-500">
                        {postDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </span>
                </div>

                {/* Caption Preview */}
                <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                    {post?.caption ? truncateCaption(post.caption) : ''}
                </p>

                {/* Engagement Stats */}
                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <div className="flex items-center gap-4">
                        <span className="text-xs text-gray-500 flex items-center gap-1">
                            <Heart size={14} className="text-red-400" />
                            {post.like_count}
                        </span>
                        <span className="text-xs text-gray-500 flex items-center gap-1">
                            <MessageCircle size={14} />
                            {Math.floor(Math.random() * 30) + 5}
                        </span>
                    </div>
                    <a
                        href={post.permalink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-teal-500 hover:text-teal-600 text-xs font-medium flex items-center gap-1"
                    >
                        View Post
                        <ExternalLink size={12} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default InstagramPost;